// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* The rename input lives inside PageHeader's h1 and inherits its type. */\n.highlight-name[data-v-87caa36c],\n.highlight-name-twin[data-v-87caa36c] {\n\tfont: inherit;\n\tletter-spacing: inherit;\n\tline-height: inherit;\n\tcolor: inherit;\n}\n.highlight-name-wrap[data-v-87caa36c] {\n\tmin-width: 6ch;\n\tmax-width: min(100%, 48rem);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
